import { Link } from "react-router-dom";
import Slider from "react-slick";
import useWidth from "../../hooks/useWidth";
import { convertToUrl } from "../../libraries/ercLibrary";
import LoadingBox from "../../modules/shared/components/LoadingBox";

export default function SideProductSlideShow({ loading, sideProducts }) {
  const width = useWidth();

  const settings = {
    dots: true, // This will show dot indicators at the bottom
    infinite: true,
    speed: 500,
    slidesToShow: width < 600 ? 2 : 4,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  const styleSlider = {
    maxWidth: "100%",
    overflow: "hidden",
    // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    margin: "0 0 1rem 0",
  };

  return (
    <>
      {loading && <LoadingBox></LoadingBox>}
      {sideProducts && (
        <>
          <h1 className="padupside1 txtcenter fs125 w90p bold-font">
            Birlikte Alınan Ürünler
          </h1>
          {(width < 600 && sideProducts.length < 3) ||
          (width >= 600 && sideProducts.length < 5) ? null : (
            <h2 className="txtcenter fs125 padupsideq w90p">
              Daha çok ürün için{" "}
              <span className="beddo-border-bottom">KAYDIR</span>
            </h2>
          )}
          <div style={styleSlider}>
            {sideProducts?.length > 0 && (
              <Slider {...settings}>
                {sideProducts.map((sideProduct, index) => {
                  return (
                    <div key={index} className="w100p row-left">
                      <div className="mar1 col-space-between fs125 shadow-all rad5r h20r whitebck">
                        <Link
                          className="col-jus"
                          to={`/urun/${convertToUrl(sideProduct.name)}/${
                            sideProduct._id
                          }`}
                        >
                          <img
                            className="item-product-img"
                            src={sideProduct.defaultImages[0]}
                            alt="beddo product"
                          />
                        </Link>
                        <p className="padh w95p">{sideProduct.name}</p>

                        <Link
                          className="col nodeco"
                          to={`/urun/${convertToUrl(sideProduct.name)}/${
                            sideProduct._id
                          }`}
                        >
                          <button className="w95p primary-free marq">
                            Şimdi İncele
                          </button>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            )}
          </div>
        </>
      )}
    </>
  );
}
